<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Update Student',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      userError: null,
      isUserError: false,
      isLoading: false,
      show: false,
      userId: null,
      userSuccess: '',
      isSuccess: false,
      departmentlist: [],
      departmentId: '',
      phone: '',
      collegeId: '',
      collegeClass: [],
      classlist: [],
      classEmptyError: false,
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    this.getDepartments()
    this.collegeId = this.profileData.college_id
    if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
    }
  },
  methods: {
    ...userListMethod,
    ...departmentListMethod,
    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
    // save user method
    saveUserDetails() {
      if (this.collegeClass.length === 0 || this.departmentId.length === 0) {
        this.classEmptyError = true
        this.isLoading = false
      } else {
        this.classEmptyError = false
      }
      if (!this.classEmptyError) {
        let Data = {
          id: this.data._id,
          first_name: this.firstName,
          last_name: this.lastName,
          department: this.departmentId,
          collegeClass: this.collegeClass,
        }
        if (this.phone.toString() !== this.data.phone.toString()) {
          Data.phone = this.phone
        }
        this.updateUser({ Data })
          .then((user) => {
            this.isLoading = false
            this.isUserError = false
            this.userSuccess = 'Details Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.userError = getError.message
            this.isUserError = true
          })
      }
    },

    resetModal() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.phone = this.data.phone
      this.department = this.data.department
      this.userError = ''
      this.isUserError = false
      this.userSuccess = ''
      this.isSuccess = false
      this.departmentId = ''
      this.classEmptyError = false
    },
    getData() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.departmentId = this.data.department
      this.getClasses()
      this.phone = this.data.phone
      for (let i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
      }
    },

    getClasses() {
      this.collegeClass = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            if (this.departmentId === element.department) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            }
          })
          this.classlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="user-edit-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="userSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveUserDetails">
          <b-form-group label="First Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="firstName"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Last Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="lastName"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Email" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="data.email"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Phone" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="phone"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              @change="getClasses"
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Class" label-for="input-1">
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <p v-if="classEmptyError" style="color:red;"
            >Please select class/department</p
          >
          <b-alert
            v-model="isUserError"
            variant="danger"
            v-html="userError"
          ></b-alert>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
